import React, { Fragment } from "react";
const PollInput = ({ pollHeader, answers }) => {
  return (
    <Fragment>
      <p className="poll-header">{pollHeader}</p>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        {answers.map((answer) => (
          <div className="answer">
            <p>{answer}</p>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default PollInput;



// WEBPACK FOOTER //
// ./src/screens/Articles/components/PollInput.js